import { Injectable } from '@angular/core';
import { APP_PRIVATE_PATHS } from '@epicuro-next/navigation/constants';
import { IntercomService } from '@epicuro-next/platform/intercom';
import {
  checkBasketSuccess,
  selectBasketRealTotals,
  selectIsBasketStatusValid,
  selectOpenedBasketId,
  selectOrderReferenceNumber,
  submitBasketSuccess,
} from '@epicuro-next/state/basket-state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { select, Store } from '@ngrx/store';
import { filter, tap } from 'rxjs/operators';

@Injectable()
export class BasketEffects {
  constructor(
    private actions$: Actions,
    private intercom: IntercomService,
    private store: Store,
  ) {}

  public basketSuccessActions$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(checkBasketSuccess, submitBasketSuccess),
        concatLatestFrom(() => [
          this.intercom.isBooted$,
          this.store.pipe(select(selectOpenedBasketId)),
          this.store.pipe(select(selectOrderReferenceNumber)),
          this.store.pipe(select(selectIsBasketStatusValid)),
          this.store.pipe(select(selectBasketRealTotals)),
        ]),
        filter(([, isBooted]) => isBooted),
        tap(
          ([
            action,
            ,
            openedBasketId,
            orderReferenceNumber,
            isBasketStatusValid,
            basketTotals,
          ]) => {
            this.intercom.trackEvent(
              action.type === checkBasketSuccess.type
                ? 'check-order'
                : 'place-order',
              {
                basketId: openedBasketId,
                basket: {
                  url: `${document.location.origin}/${APP_PRIVATE_PATHS.basket.path}/${openedBasketId}`,
                  value: orderReferenceNumber,
                },
                result: isBasketStatusValid ? 'success' : 'failed',
                action_date: new Date().getTime() / 1000,
                requestedQuantity: basketTotals.requested.quantity,
                confirmedQuantity: basketTotals.confirmed?.quantity || 0,
                netvalue: {
                  amount: basketTotals.requested.net,
                  currency: basketTotals.requested.currency,
                },
              },
            );
          },
        ),
      ),
    { dispatch: false },
  );
}
